import React, { useState } from "react";
import { Slider } from "@mui/material";
import ColourBar from "./ColourBar.tsx";
import config from "../config.ts";

// The "show areas reachable within X minutes" picker with its colour scale.
const MaxMinutesSlider = ({
  maxMinutes,
  setMaxMinutes,
}: {
  maxMinutes: number;
  setMaxMinutes: (mins: number) => void;
}) => {
  // Local while dragging; committed on release because repainting the map
  // is the expensive part.
  const [draftMinutes, setDraftMinutes] = useState(maxMinutes);

  return (
    <div>
      <label className="text-sm text-gray-500">
        Show areas reachable within{" "}
        <span className="font-semibold text-gray-700">{draftMinutes} min</span>
      </label>
      <div className="px-1">
        <Slider
          size="small"
          value={draftMinutes}
          min={10}
          max={config.maxTravelMins}
          step={5}
          onChange={(_, value) => setDraftMinutes(value as number)}
          onChangeCommitted={(_, value) => setMaxMinutes(value as number)}
          sx={{ color: "#4b5563" }}
        />
      </div>

      <div className="mt-1 [&>div]:w-full">
        <ColourBar />
      </div>
      <div className="flex justify-between pt-1 text-[10px] text-gray-400">
        <span>0 min</span>
        <span>{draftMinutes} min</span>
      </div>
    </div>
  );
};

export default MaxMinutesSlider;
